import type { ColumnTone } from '@voll-intelligence/domain';

import { Dot, Tooltip } from '@web/ui/core/atoms';
import { twcn } from '@web/ui/core/utils';

export type { ColumnTone } from '@voll-intelligence/domain';

const LABEL_CLASS =
  'text-meta font-medium uppercase tracking-eyebrow-narrow text-foreground whitespace-nowrap';

/**
 * Column header — tone dot + uppercase mono label + tabular-nums count.
 * When `hint` is set the label becomes a tooltip trigger describing the
 * condition for a card to land in this column.
 */
export function ColumnHead({
  tone,
  label,
  count,
  hint,
}: Readonly<{
  tone: ColumnTone;
  label: string;
  count: number;
  hint?: string;
}>): React.JSX.Element {
  return (
    <header className="flex items-center gap-2 px-2 pb-2.5">
      <Dot pulse tone={tone} size="md" />
      {hint ? (
        <Tooltip label={hint}>
          <button
            type="button"
            className={twcn(
              LABEL_CLASS,
              'cursor-help outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded-sm',
            )}
          >
            {label}
          </button>
        </Tooltip>
      ) : (
        <span className={LABEL_CLASS}>{label}</span>
      )}
      <span className="font-mono text-card-id text-muted-foreground tabular-nums">{count}</span>
    </header>
  );
}
